import HomeSlide from './HomeSlide';

export default HomeSlide;
